import { useEffect as o, useState as s, useCallback as c } from "react";
import { n as i } from "./noop-ClDc6zv4.js";
const a = (t) => {
  o(() => {
    typeof t == "function" && t();
  }, []);
}, d = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
}, b = (t, n, r = d) => {
  o(() => {
    if (t.current) {
      const e = new MutationObserver(n);
      return e.observe(t.current, r), () => {
        e.disconnect();
      };
    }
    return i;
  }, [n, r, t]);
}, l = (t) => {
  const [n, r] = s(null), e = c(() => {
    var u;
    r(((u = t.current) == null ? void 0 : u.getBoundingClientRect()) ?? null);
  }, [t]);
  return a(() => {
    e();
  }), b(t, e), n;
};
export {
  a,
  b,
  l as u
};
//# sourceMappingURL=use-bounding-client-rect-DuREs_dA.js.map
